import { Popover, Spin } from 'antd';
import { IconProps } from 'react-feather';
import { Link } from 'react-router-dom';
import { ImEye } from 'react-icons/im';

interface Props {
  redirect?: string;
  target?: React.HTMLAttributeAnchorTarget;
  iconProps?: IconProps;
  disabled?: boolean;
  content?: string;
  loading?: boolean;
}

const EyeIcon: React.FC<Props> = ({
  redirect,
  iconProps,
  disabled,
  content = 'Visualizar',
  loading = false,
  ...props
}) => {
  const icon = (
    <ImEye
      size={20}
      cursor={'pointer'}
      style={{
        cursor: disabled ? 'not-allowed' : undefined,
        color: disabled ? 'darkgray' : undefined,
        pointerEvents: disabled ? 'none' : undefined,
        ...iconProps?.style,
      }}
      {...iconProps}
    />
  );

  const wrappedIcon = loading ? <Spin size="small">{icon}</Spin> : icon;

  return (
    <Popover content={content}>
      {redirect ? (
        <Link
          to={redirect}
          style={{ pointerEvents: disabled ? 'none' : undefined }}
          target={props.target}
        >
          {wrappedIcon}
        </Link>
      ) : (
        wrappedIcon
      )}
    </Popover>
  );
};

export default EyeIcon;
